export default __webpack_public_path__ + "static/media/draw_toilet.65edf08c.png";